import styled from 'styled-components';

export const ButtonChipStyled = styled.div`
  
  .npsButton{
    border-radius: 50rem;
    padding: 0.56rem 1rem !important;
    font-family: Mulish;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    margin: 0 0.25rem;
    color: #31363C;
    border-color: #E3E9EF;
    margin-bottom: 16px;
    &.btnSelected{
        color: #1976D2;
        border-color: #1976D2;
        background-color: #F2F8FD;
    }
    &.disable{
        pointer-events: none;
    }
    &:hover{
        color: #1976D2 !important;
        border-color: #1976D2;
        background: #F2F8FD !important; 
        background-color: #F2F8FD;
    }
  }
  .npsButton:first-child{
    margin-left: 0;
  }

`;
